import styled from "styled-components";
import { CalendarDetails } from "@lifeat/shared/data-models/calendar/CalendarDetails";
import LifeAtCheckbox from "@common/LifeAtCheckbox/LifeAtCheckbox";
import { UserContextType, useUserContext } from "@contexts/UserContext";

const SelectorElementWrapper = styled.div<{ isDisabled: boolean; blockClick: boolean }>`
    margin-left: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    opacity: ${(props) => (props.isDisabled ? 0.5 : 1.0)};

    cursor: ${(props) => (props.blockClick ? "not-allowed" : "pointer")};

    div > * {
        cursor: ${(props) => (props.blockClick ? "not-allowed" : "pointer")};
    }
`;

const CalendarNameWrapper = styled.span<{ highlight: boolean }>`
    width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // Highlight the name of the currently selected calendar
    color: ${(props) => (props.highlight ? props.theme.textColorSpecial : props.theme.textColorPrimary)};
`;

interface CalendarSelectorElementProps {
    readonly calendar: CalendarDetails;
    readonly isActive: boolean;
    readonly onChange: (value: boolean) => void;
    readonly blockClick: boolean;
}
function CalendarSelectorElement(props: CalendarSelectorElementProps) {
    const { userData }: UserContextType = useUserContext();

    const allowNonPrimaryCalendarClick = props.calendar.isPrimary || userData?.proUserInfo?.isProUser;

    const handleClick = () => {
        if (!props.blockClick) {
            props.onChange(!props.isActive);
        }
    };

    return (
        <SelectorElementWrapper
            onClick={(e) => {
                e.stopPropagation();
                handleClick();
            }}
            isDisabled={!allowNonPrimaryCalendarClick}
            blockClick={props.blockClick}
        >
            <CalendarNameWrapper highlight={props.isActive}>
                {props.calendar.calendarName?.length > 30
                    ? `${props.calendar.calendarName.substring(0, 30)}...`
                    : props.calendar.calendarName}
                {props.calendar.isPrimary && " (Primary)"}
            </CalendarNameWrapper>
            <LifeAtCheckbox
                checked={props.isActive}
                handleToggle={() => {
                    handleClick();
                }}
                id={props.calendar.calendarId}
            />
        </SelectorElementWrapper>
    );
}
export default CalendarSelectorElement;
